export function getDomain() {
    const hostname = window.location.hostname;
  
    // Exclude localhost
    if (hostname === 'localhost') return undefined;
  
    // Exclude IP addresses
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return undefined;
  
    const parts = hostname.split('.');
  
    if (parts.length >= 2) {
      const domain = parts.slice(-2).join('.');
      return domain;
    }
  
    return undefined;
  }
  

  export function setCookie(name, value, { days, path, domain }) {
    let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}`;
  
    if (typeof days === 'number') {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      cookieStr += `; expires=${expires}`;
    }
  
    if (domain) {
      cookieStr += `; domain=${domain}`;
    }
  
    document.cookie = cookieStr;
  }
  
  
  export function getCookie(name) {
    const cookies = document.cookie.split('; ').reduce((acc, cookieStr) => {
      const [key, val] = cookieStr.split('=');
      acc[decodeURIComponent(key)] = decodeURIComponent(val);
      return acc;
    }, {});
    return cookies[name];
  }
  
  export function deleteCookie(name, { path, domain }) {
    let cookieStr = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
    if (domain) {
      cookieStr += `; domain=${domain}`;
    }
    document.cookie = cookieStr;
  }


  export function setUserCookie(user) {
    let domain = getDomain();
    if (domain) {
      domain = "." + domain;
    }
    setCookie("user", JSON.stringify(user), { path: "/", domain });
  }

  export function getUserCookie() {
    return JSON.parse(getCookie("user") || "null");
  }

  export function deleteUserCookie() {
    let domain = getDomain();
    if (domain) {
      domain = "." + domain;
    }
    deleteCookie("user", { path: "/", domain });
  }

  /**
   * Set logout signal cookie for cross-domain logout
   */
  export function setLogoutSignal() {
    let domain = getDomain();
    const timestamp = Date.now().toString();
    
    // Set logout signal with domain for cross-subdomain sharing
    if (domain) {
      domain = "." + domain;
      setCookie("logout_signal", timestamp, { 
        path: "/", 
        domain,
        days: 1/1440 // Expire in 1 minute (1/1440 days)
      });
    }
    
    // Also set without domain for same domain
    setCookie("logout_signal", timestamp, { 
      path: "/",
      days: 1/1440 // Expire in 1 minute
    });
  }

  /**
   * Clear logout signal cookie
   */
  export function clearLogoutSignal() {
    let domain = getDomain();
    
    // Clear with domain
    if (domain) {
      domain = "." + domain;
      deleteCookie("logout_signal", { path: "/", domain });
    }
    
    // Clear without domain
    deleteCookie("logout_signal", { path: "/" });
  }

  /**
   * Check if logout signal exists and is recent
   */
  export function checkLogoutSignal() {
    const signal = getCookie("logout_signal");
    if (!signal) return false;
    
    const timestamp = parseInt(signal);
    const now = Date.now();
    
    // Check if signal is less than 60 seconds old
    return (now - timestamp) < 60000;
  }

// export function getDomain() {
//     const hostname = window.location.hostname;
  
//     // Exclude localhost
//     if (hostname === 'localhost') return undefined;
  
//     // Exclude IP addresses
//     if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return undefined;
  
//     const parts = hostname.split('.');
  
//     if (parts.length >= 2) {
//       const domain = parts.slice(-2).join('.');
//       return domain;
//     }
  
//     return undefined;
//   }
  

//   export function setCookie(name, value, { days, path, domain }) {
//     let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}`;
  
//     if (typeof days === 'number') {
//       const expires = new Date(Date.now() + days * 864e5).toUTCString();
//       cookieStr += `; expires=${expires}`;
//     }
  
//     if (domain) {
//       cookieStr += `; domain=${domain}`;
//     }
  
//     document.cookie = cookieStr;
//   }
  
  
//   export function getCookie(name) {
//     const cookies = document.cookie.split('; ').reduce((acc, cookieStr) => {
//       const [key, val] = cookieStr.split('=');
//       acc[decodeURIComponent(key)] = decodeURIComponent(val);
//       return acc;
//     }, {});
//     return cookies[name];
//   }
  
//   export function deleteCookie(name, { path, domain }) {
//     let cookieStr = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
//     if (domain) {
//       cookieStr += `; domain=${domain}`;
//     }
//     document.cookie = cookieStr;
//   }


//   export function setUserCookie(user) {
//     let domain = getDomain();
//     if (domain) {
//       domain = "." + domain;
//     }
//     setCookie("user", JSON.stringify(user), { path: "/", domain });
//   }

//   export function getUserCookie() {
//     return JSON.parse(getCookie("user") || "null");
//   }

//   export function deleteUserCookie() {
//     let domain = getDomain();
//     if (domain) {
//       domain = "." + domain;
//     }
//     deleteCookie("user", { path: "/", domain });
//   }

  